module.exports = __webpack_public_path__ + "img/Illu_Home.e77b7137.svg";